<div *ngIf="updaterJoined">
  {{ updaterName }} joined the conversation {{ dateString }}.
</div>

<div *ngIf="addedNames.length">
  {{ updaterName }} added
  <span *ngFor="let userName of addedNames; last as isLast">
    {{ addedNames.length > 2 && isLast ? 'and' : '' }} {{ userName }}
  </span>
  {{ dateString }}
</div>

<div *ngIf="removedNames.length">
  {{ updaterName }} removed
  <span *ngFor="let userName of removedNames; last as isLast">
    {{ removedNames.length > 2 && isLast ? 'and' : '' }} {{ userName }}
  </span>
  {{ dateString }}
</div>

<div *ngIf="updaterLeft">
  {{ updaterName }} left the conversation {{ dateString }}.
</div>
